exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cardsDiv{position:absolute;z-index:9;cursor:move;background-color:#f1f1f1;border:1px solid #f1f1f1;text-align:center;opacity:.8;box-shadow:0 0 40px -10px rgba(0,0,0,.8)}.list-group-item{background-color:#1e1e1e;box-shadow:0 0 40px -10px hsla(0,0%,100%,.8)}.listLetter{color:#f1f1f1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c65f5756","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/monitoramento/main.vue
// module id = 413
// module chunks = 0